import { PropsWithChildren, useState } from "react";
import { Button, InputText, Span } from "@goodfill/ui-components";
import { FinancialInformation } from "@goodfill/domain-customer-application-types";
import { formatCurrencyAmount } from "@goodfill/format-number";

interface Props {
  saveAccountInformation?: ({ lorem }: { lorem: string }) => void;
  saveFinancialInformation?: ({ lorem }: { lorem: string }) => void;
  financialInformation: FinancialInformation;
}

type FieldProps = PropsWithChildren<{
  label: string;
}>;

const Field: React.FC<FieldProps> = ({ children, label }) => {
  return (
    <div className="flex-col md:flex-row border-b border-neutral-110 justify-between items-center gap-2 md:gap-4">
      <div className="field-label">
        <Span font="light" size="sm">
          {label}
        </Span>
      </div>
      {children}
    </div>
  );
};

export const FinancialInformationSection: React.FC<Props> = ({
  saveAccountInformation,
  // saveFinancialInformation,
  financialInformation,
}) => {
  const editLabel = "edit";
  const saveLabel = "save";

  const [lorem] = useState("lorem");

  const [accountInformationIsEditing, setAccountInformationIsEditing] = useState(false);
  // const [financialInformationIsEditing, setFinancialInformationIsEditing] = useState(false);

  const onClickAccountInformationAction = () => {
    if (accountInformationIsEditing) {
      saveAccountInformation?.({ lorem });
      setAccountInformationIsEditing(false);
    } else {
      setAccountInformationIsEditing(true);
    }
  };

  // const onClickFinancialInformationAction = () => {
  //   if (financialInformationIsEditing) {
  //     saveFinancialInformation?.({ lorem });
  //     setFinancialInformationIsEditing(false);
  //   } else {
  //     setFinancialInformationIsEditing(true);
  //   }
  // }

  return (
    <div className="page-account-info-financial-info">
      <div className="flex flex-col my-1 md:my-2 mx-4 md:mx-8 px-4 md:px-8 gap-4 md:gap-8">
        <div className="flex flex-col">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Net Worth
            </Span>
            <Button fill className="w-fit" size="small" onClick={onClickAccountInformationAction}>
              {accountInformationIsEditing ? saveLabel : editLabel}
            </Button>
          </div>
          <div className="flex flex-col px-1 md:px-2">
            <Field label="Net Worth">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={formatCurrencyAmount({ value: financialInformation.netWorth.amount, numDecimals: 0 })}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Liquid net worth">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={formatCurrencyAmount({ value: financialInformation.liquidNetWorth.amount, numDecimals: 0 })}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Annual net income">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={formatCurrencyAmount({ value: financialInformation.annualNetIncome.amount, numDecimals: 0 })}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Source of Wealth
            </Span>
            <Button fill className="w-fit" size="small" onClick={onClickAccountInformationAction}>
              {accountInformationIsEditing ? saveLabel : editLabel}
            </Button>
          </div>
          <div className="flex flex-col px-1 md:px-2">
            <Field label="Source of wealth no.">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value=""
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Type">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={`${financialInformation.sourcesOfWealth[0].type
                  .charAt(0)
                  .toUpperCase()}${financialInformation.sourcesOfWealth[0].type.slice(1)}`}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Frequency">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={`${financialInformation.sourcesOfWealth[0].frequency
                  .charAt(0)
                  .toUpperCase()}${financialInformation.sourcesOfWealth[0].frequency.slice(1)}`}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Is Used for Funds">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={financialInformation.sourcesOfWealth[0].isUsedForFunds ? "Yes" : "No"}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center justify-between my-2 md:my-4">
            <Span font="semibold" size="lg">
              Bond Investment Experience
            </Span>
            <Button fill className="w-fit" size="small" onClick={onClickAccountInformationAction}>
              {accountInformationIsEditing ? saveLabel : editLabel}
            </Button>
          </div>
          <div className="flex flex-col px-1 md:px-2">
            <Field label="Years Trading">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={financialInformation.investmentExperience.bonds.yearsTrading}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Trades Per Year">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={financialInformation.investmentExperience.bonds.tradesPerYear}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
            <Field label="Knowledge Level">
              <InputText
                neutral={true}
                // placeholder="salutation"
                value={`${financialInformation.investmentExperience.bonds.knowledgeLevel
                  .charAt(0)
                  .toUpperCase()}${financialInformation.investmentExperience.bonds.knowledgeLevel.slice(1)}`}
                // setValue={setName}
                disabled={!accountInformationIsEditing}
              />
            </Field>
          </div>
        </div>
      </div>
    </div>
  );
};
